import * as yup from "yup";

const DEFAULT_MSG = "Este campo es requerido."

const pageSchema = yup.object().shape({
    title: yup.string().required(DEFAULT_MSG),
    published: yup.number().moreThan(-1, DEFAULT_MSG).required(DEFAULT_MSG)
});

export {
    pageSchema
}